import { Text, Flex } from '@cdl/heartbeat-react';
import React, { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { hasAutoLabelsAndNoDelineationsSelector } from '../../delineation/selectors/delineation.selectors';
import { useCopyDiagnostic } from '../hooks/useCopyDiagnostic';
import { loadDefinitions } from '../thunks/load-definitions.thunk';
import { CommentEditor } from './CommentEditor';
import { DiagnosticPicker } from './DiagnosticPicker';
import { OverlayMessage } from './OverlayMessage';
import { diagnosticChangedSelector } from '../selectors/user-diagnostic.selectors';
import { hasPrimaryDefinitionsSelector } from '../selectors/diagnostic.selectors';
import { booleanPreferenceSelector } from '../../auth/selectors/auth.selectors';
import { AutoDiagnosticLabels } from './AutoDiagnosticLabels';
import { SavedStatus } from 'features/delineation/components/SavedStatus';
import { SidebarSection } from '../../../shared/components/SidebarSection';
import { needToAssessSelector } from '../../autoLabels/selectors/auto-labels.selectors';
import { Overlay } from './Overlay';

export const DiagnosticEditor: React.FC = () => {
  useCopyDiagnostic();
  const hasAutoLabelsAndNoDelineation = useSelector(
    hasAutoLabelsAndNoDelineationsSelector,
  );
  const needToAssess = useSelector(needToAssessSelector);
  const isDisabled = hasAutoLabelsAndNoDelineation || needToAssess;

  const dispatch = useDispatch();
  const diagnosticChanged = useSelector(diagnosticChangedSelector);
  const hasPrimaryDefinitions = useSelector(hasPrimaryDefinitionsSelector);
  const hasAutoDiagnostic = useSelector(
    booleanPreferenceSelector('autoDiagnostic'),
  );

  useEffect(() => {
    dispatch(loadDefinitions());
  }, [dispatch]);

  return (
    <SidebarSection
      bgColor='neutral.0'
      data-testid='diagnostic-editor'
      position='relative'
    >
      <Flex justifyContent='space-between' align='center'>
        <Text textStyle='section-subtitle'>My Diagnosis</Text>
        <SavedStatus changed={diagnosticChanged} />
      </Flex>
      {hasPrimaryDefinitions && hasAutoDiagnostic && <AutoDiagnosticLabels />}
      <DiagnosticPicker />
      <CommentEditor />
      {isDisabled && (
        <Overlay data-testid='diagnostic-overlay'>
          {hasAutoLabelsAndNoDelineation && (
            <OverlayMessage message='Import or edit the Beat Annotation to start your diagnostic.' />
          )}
        </Overlay>
      )}
    </SidebarSection>
  );
};
